module.exports = __webpack_public_path__ + "static/media/ourPrice.4a367704.svg";